export function capitalizeFirstLetter(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function pascalToSnakeCase(str) {
  return str.split(/(?=[A-Z])/).join('_').toLowerCase();
}
